import React, { useEffect } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux'
import { ToastContainer } from 'react-toastify';
import { RouteConstants } from '../router/services/RouteConstants';
import lang from '../components/language/services/Lang';
import AddLoadConfiguration from '../components/app-initialization/AddLoadConfiguration';
import SideNav from '../components/layout/SideNav';
import PrivateRoute from '../router/PrivateRoute';
import HomePage from '../pages/home/HomePage'
import LoginCallback from '../components/login/loginCallback'
import Clients from '../components/clients/clients'
import Logout from '../components/logout/logout';
import Unauthorized from '../components/unauthorized/unauthorized';
import ClientInfoPage from '../pages/client-info/ClientInfoPage'
import PresalePage from '../pages/diy-presale/DIYPresalePage'
import DiyReturnPage from '../pages/diy-return/DiyReturnPage';
import ReturnStatusPage from '../pages/diy-filed-return/diyFiledReturnPage'
import ErrorPage from '../components/error/ErrorPage'
import ErrorBoundary from '../components/error/ErrorBoundary'
import PartyInfoPage from '../components/party/partyInfoPage'
import QueuePage from '../pages/queue/QueuePage'
import UnassignedQueuePage from '../pages/queue/UnassignedQueuePage'
import TicketPage from '../pages/vdo-ticket/TicketPage';
import OfficesPage from '../pages/offices/OfficesPage';
import LoadingSpinner from '../components/library/loaders/LoadingSpinner';

import '../components/layout/Layout.scss';
import 'react-toastify/dist/ReactToastify.css';
import AppContainer from '../components/layout/AppContainer';
import { UnreadMessagesContextProvider } from '../pages/vdo-ticket/contexts/UnreadMessagesContext';
import { Permissions } from './services/Permissions';
import OTECaseInfoPage from '../pages/ote-case/OTECaseInfoPage';
import DistrictSummaryPage from '../pages/districts/DistrictSummaryPage';
import AssociatesPage from '../pages/associates/AssociatesPage';
import ReassignQueuePage from '../pages/queue/ReassignQueuePage'

const App = () => {

    const appName = useSelector(state => `${lang.getValue('App.Name1', state.layout.lang)}${lang.getValue('App.Name2', state.layout.lang)}`)
    const { id: ticketId, targetId: clientId } = useSelector(state => state.tickets.selectedTicket || {}, shallowEqual);
    const showQueue = useSelector(state => (state.accountData.permissions || []).includes(Permissions.EDIT_TICKET))
    const canViewOtherQueues = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_ALL_QUEUES)
        || (state.accountData.permissions || []).includes(Permissions.VIEW_DISTRICT_QUEUES))
    const canViewDistrictSummary = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_DISTRICT_OFFICES))
    const canViewOfficeSummary = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_ALL_OFFICES)
        || (state.accountData.permissions || []).includes(Permissions.VIEW_OFFICE_EMPLOYEES))
    // This variable is used to prevent a redirect to home before the permissions are loaded
    const isPageLoading = useSelector(state => state.layout.isPageLoading)
    const hasReassignPermission = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_MANAGE_TAB))
    const canViewFiledViewModels = useSelector(state => (state.accountData.permissions || []).includes(Permissions.VIEW_EXPERT_REVIEW_ADMIN))

    useEffect(() => {
        window.document.title = appName
    }, [])

    useEffect(() => {
        window.document.title = appName
    }, [appName])

    return (
        <div className='hrbspark newspark'>
            <Switch>
                <Route path={[
                    RouteConstants.HOME,
                    RouteConstants.TICKET_QUEUE,
                    RouteConstants.UNASSIGNED_VDO,
                    RouteConstants.MY_ASSOCIATES,
                    RouteConstants.TICKET,
                    RouteConstants.OFFICES,
                    RouteConstants.DISTRICTS,
                    RouteConstants.CLIENTS_SEARCH,
                    RouteConstants.CLIENT_INFO,
                    RouteConstants.RETURN_INFO,
                    RouteConstants.PRESALE_INFO,
                    RouteConstants.RETURN_STATUS,
                    RouteConstants.RETURN_INFO,
                    RouteConstants.OTE_INFO,
                    RouteConstants.PARTY_INFO,
                    RouteConstants.RETURN_STATUS_BY_VMID,
                    RouteConstants.REASSIGN]}><SideNav /></Route>
            </Switch>
            <Switch>
                <Route path="*" >
                    <AppContainer>
                        <ErrorBoundary>
                            <UnreadMessagesContextProvider ticketId={ticketId} clientId={clientId}>
                                <Switch>
                                    <Route path={RouteConstants.AUTH_CALLBACK}><LoginCallback /></Route>
                                    <Route path={RouteConstants.LOGOUT}><Logout /></Route>
                                    <Route path={RouteConstants.UNAUTHORIZED}><Unauthorized /></Route>
                                    <Route path={RouteConstants.ERROR}><ErrorPage /></Route>
                                    {isPageLoading &&
                                        <PrivateRoute path='*'><LoadingSpinner /></PrivateRoute>
                                    }
                                    <PrivateRoute path={RouteConstants.HOME}>{
                                        canViewDistrictSummary ?
                                            <DistrictSummaryPage /> :
                                            showQueue ? <QueuePage /> : <HomePage />}
                                    </PrivateRoute>

                                    {canViewOtherQueues && 
                                        <PrivateRoute path={RouteConstants.TICKET_QUEUE}><QueuePage /></PrivateRoute>
                                    }
                                    {canViewOfficeSummary && 
                                        <PrivateRoute path={RouteConstants.OFFICES}><OfficesPage /></PrivateRoute>
                                    }
                                    <PrivateRoute path={RouteConstants.MY_TICKET_QUEUE}><QueuePage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.CLIENTS_SEARCH}><Clients /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.CLIENT_INFO}><ClientInfoPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.RETURN_INFO}><DiyReturnPage hideJsonButtons={!canViewFiledViewModels} /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.PRESALE_INFO}><PresalePage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.RETURN_STATUS}><ReturnStatusPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.OTE_INFO}><OTECaseInfoPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.PARTY_INFO}><PartyInfoPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.TICKET}><TicketPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.UNASSIGNED_VDO}><UnassignedQueuePage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.MY_ASSOCIATES}><AssociatesPage /></PrivateRoute>
                                    <PrivateRoute path={RouteConstants.RETURN_STATUS_BY_VMID}><ReturnStatusPage /></PrivateRoute>
                                    {hasReassignPermission &&
                                        <PrivateRoute path={RouteConstants.REASSIGN}><ReassignQueuePage /></PrivateRoute>
                                    }
                                    <Redirect from='/' to='/home' />
                                </Switch>
                                <ToastContainer position="bottom-center"
                                    autoClose={5000}
                                    hideProgressBar={false}
                                    newestOnTop={true}
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable
                                    pauseOnHover />
                            </UnreadMessagesContextProvider>
                        </ErrorBoundary>
                    </AppContainer>
                </Route>
            </Switch>
        </div>)
}

export default withRouter(AddLoadConfiguration(App))